import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { copyValueLibrary, deleteValueLibrary, upsertValueLibrary } from "redux/index";
import { ColorSelectModal } from "shared/modals/colors/ColorSelectModal";
import { ActionConfirmModal, DuplicateModal } from "shared/modals/index";
import { CustomLibraryColors } from "shared/ui-basics";
import { useModal } from "use-modal-hook";
import { encode } from "utils/helpers";

export default function BaseActions({ libraryId, item, handleChange, onClose }) {
	const { t } = useTranslation();
	const inMap = useLocation().pathname === "/EditMap";
	const currentLibrary = useSelector((state) => state.libraries?.customLibraries)?.find((cl) => cl?.id === libraryId);

	const itemId = item?.id;

	const [actionConfirmModal] = useModal(ActionConfirmModal);

	const handleDelete = () => {
		actionConfirmModal({
			bodyContent: "DELETE_GENERIC",
			Action: () => {
				if (onClose) onClose();
				deleteValueLibrary({ libraryId: currentLibrary?.id, libraryValueId: item?.id });
			},
			actionBtnText: "ASPX_13",
		});
	};

	const [showCopyModal] = useModal(DuplicateModal, {
		title: `${t("JS_61")} ${t(currentLibrary?.name)}`,
		inputTitle: "NAME",
		closeBtnLabel: "COPY",
		inputValue: `${item?.name} - ${t("COPY")}`,
		action: ({ name, selectedWorkspaces }) =>
			copyValueLibrary({
				libraryId: currentLibrary?.id,
				libraryValueId: itemId,
				name,
				workspaceIds: selectedWorkspaces.map((w) => w?.id),
			}),
	});

	const [showColorModal] = useModal(ColorSelectModal, {
		selectedColor: item?.colorCode,
		colorsPanel: CustomLibraryColors,
		action: ({ selectedColor }) => {
			if (handleChange) handleChange("colorCode", selectedColor);
			upsertValueLibrary({ libraryId: currentLibrary?.id, libraryValue: { ...item, name: encode(item?.name?.truncate(100,true)), description: encode(item?.description?.truncate(20000,true)), colorCode: selectedColor } });
		},
		colorSize: 32,
	});

	const createActions = () => {
		let actions = [];
		actions.push({ id: "copy", handleClick: showCopyModal, icon: "COPY", text: t("JS_61") });
		if (item?.isCustom) actions.push({ id: "color", handleClick: showColorModal, icon: "FILL-DRIP", text: t("COLOR") });

		if (item?.isCustom && !inMap)
			actions.push({
				id: "delete",
				handleClick: handleDelete,
				icon: "DELETE",
				text: t("CS_45"),
			});

		return actions;
	};

	return createActions();
}
